import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

/**
 * Close button positioned absolutely in the top-right corner
 */
export const BannerCloseButton = styled(IconButton)(({ theme }) => ({
  // Styling
  color: theme.palette.common.white,
  padding: theme.spacing(0.5),

  // Positioning
  position: 'absolute',
  top: 15,
  right: 15,
  zIndex: 4, // Higher than content to ensure clickability

  // Icon styling
  '& svg': {
    fontSize: '20px',
    stroke: theme.palette.common.white,
  },

  // Mobile styles
  [theme.breakpoints.down('sm')]: {
    order: 1,
    alignSelf: 'flex-end',
  },
}));

/**
 * Legacy button container with responsive width behavior
 * @deprecated Use individual button styling instead
 */
export const BannerButton = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    order: 3,
    width: '100%',

    '& .MuiButton-root': {
      width: '100%',
    },
  },
}));
